import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { StyledFormWrapper } from "../../../styled-components/StyledFormWrapper.style";
import { StyledLogin } from "../../../styled-components/StyledLogin.styles";
import { LogoSis } from "../../../svg/index";
import { DynamicInput2 } from "../../../components/DynamicInput";
import { ButtonOutline } from "../../../components/ButtonOutline";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { Footer } from "../../../components/Footer";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { UserContext } from "../../../contexts/UserContext";
import { is20x } from "../../../utils/webUtils";
import api from "../../../services/api";

const StyledErrorWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    border-radius: 4%;
`;

const StyledErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    width: 75%;
`;

export const Login = () => {
    const history = useHistory();
    const { register, handleSubmit } = useForm();
    const { setUser } = useContext(UserContext);
    const [errorMessage, setErrorMessage] = useState(null);

    const ErrorMessageContainer = ({ firstLine, secondLine }) => (
        <StyledErrorWrapper>
            <StyledErrorContainer className="alert-danger">
                <p>{firstLine}</p>
                <p>{secondLine}</p>
            </StyledErrorContainer>
        </StyledErrorWrapper>
    );

    const saveProfileData = (profileData) => {
        const user = { name: profileData.name, expiration: profileData.expiration, idUsuario: profileData.idUsuario, nivel: profileData.nivel };
        setUser(user)
        localStorage.setItem('PROFILE_DATA_SISCOPE', JSON.stringify(user))
    }

    const submitUser = ({ UserId: username, Password: password }) => {
        api
            .post("Auth/login", { username, password })
            .then((response) => {
                if (is20x(response)) {
                    saveProfileData(response.data);
                    history.push("/");
                }
            })
            .catch(function (error) {
                if (error.response) {
                    if (
                        error.response.status >= 400 &&
                        error.response.status <= 499
                    ) {
                        setErrorMessage({
                            firstLine: "Erro ao tentar realizar login.",
                            secondLine: "Verifique usuário e senha.",
                        });
                    } else if (
                        error.response.status >= 500 &&
                        error.response.status <= 599
                    ) {
                        setErrorMessage({
                            firstLine: "Ocorreu um erro inesperado!",
                            secondLine: "Tente novamente em alguns instantes.",
                        });
                    }
                }
            });
    };

    return (
        <StyledLogin>
            <div className="position-relative h-100vh">
                <section className="d-flex flex-column justify-content-center align-items-center">
                    <StyledFormWrapper>
                        <LogoSis width={"240"} />

                        <h2 className="info font-weight-normal mt-4 mb-3">
                            <b>Para prosseguir,</b> identifique-se
                        </h2>

                        <StyledForm
                            direction={"column"}
                            onSubmit={handleSubmit(submitUser)}
                        >
                            <div className="position-relative mt-3 mb-4">
                                <DynamicInput2
                                    type={"text"}
                                    placeholder={"Ex: Bruno"}
                                    label={"Nome de usuário"}
                                    name={"UserId"}
                                    register={register}
                                />
                            </div>

                            <div className="position-relative mb-3">
                                <DynamicInput2
                                    type={"password"}
                                    placeholder={"Senha"}
                                    label={"Senha"}
                                    name={"Password"}
                                    register={register}
                                />
                            </div>

                            <div className="d-flex justify-content-between align-items-end my-3 flex-column">
                                <div className="d-flex position-relative">
                                    <ButtonOutline
                                        type={"submit"}
                                        outlineColor={"#0675BD"}
                                        backgroundColor={"#0675BD"}
                                        color={"#fff"}
                                        text={"Acessar"}
                                    />
                                </div>
                            </div>
                            {errorMessage !== null && (
                                <ErrorMessageContainer
                                    firstLine={errorMessage.firstLine}
                                    secondLine={errorMessage.secondLine}
                                />
                            )}
                        </StyledForm>
                    </StyledFormWrapper>
                </section>

            </div>
        </StyledLogin>
    );
};
